<script lang="ts">
  import ShareButton from "./ShareButton.svelte";
  import Icon from "../Icon.svelte";

  export let url: string;
  export let personalLink: boolean = false;

  let href: any;

  $: href = personalLink
    ? encodeURI(url)
    : encodeURI(`https://facebook.com/sharer/sharer.php?u=${url}`);

</script>

<ShareButton {href}>
  <Icon width="32" height="32" type="FacebookCircle" />
</ShareButton>
